import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import useOutsideClick from '../hooks/useOutsideClick';

const Tabs = ({ tabs, selectedTab, setSelectedTab }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useOutsideClick(dropdownRef, setIsOpen);

  const handleSelect = tab => {
    setSelectedTab(tab);
  };

  return (
    <>
      <div className="advanced-search__tabs">
        {tabs && tabs.length
          ? tabs.map((tab, i) => (
              <div
                className="advanced-search__tab-item"
                key={i}
                data-selected-tab={tab.value === selectedTab.value}
                onClick={() => handleSelect(tab)}
              >
                {tab.label}
              </div>
            ))
          : ''}
      </div>
      <div
        className="advanced-search__tabs-dropdown"
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        ref={dropdownRef}
      >
        <label className="advanced-search__tabs-label">
          {selectedTab.label}
        </label>
        <div className="advanced-search__tabs-dropdown-list">
          {tabs && tabs.length
            ? tabs.map((tab, i) => (
                <div
                  className="advanced-search__tab-item"
                  key={i}
                  data-selected-tab={tab.value}
                  onClick={() => handleSelect(tab)}
                >
                  {tab.label}
                </div>
              ))
            : ''}
        </div>
      </div>
    </>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  selectedTab: PropTypes.object.isRequired,
  setSelectedTab: PropTypes.func.isRequired
};

export default Tabs;
